import React from "react";
import { Form, Formik, Field } from "formik";
import { ApiService } from "../../../../../../services/ApiService";
import DatePicker from "react-datepicker";

export default function CreateExpenditure({
  closeModal,
  alert,
  getExpenditures,
  request_category,
  request_type,
  request_id,
}) {
  return (
    <React.Fragment>
      <div className="">
        <h4 className="modal-title w-100" style={{ color: "#000" }}>
          Create Expenditure
        </h4>
        <hr />
      </div>
      <Formik
        initialValues={{
          request_type: request_type,
          // request_category: request_category,
          expenditure_date: new Date(),
          description: "",
          price: "",
          request: request_id,
        }}
        onSubmit={(values, { setSubmitting }) => {
          values.expenditure_date = new Date(
            values.expenditure_date.getTime() +
              Math.abs(values.expenditure_date.getTimezoneOffset() * 60000)
          );
          console.log("date", values.expenditure_date);
          ApiService.post("expenditures", values).then((res) => {
            if (res.data.type === false) {
              alert.error(res.data.msg);
              closeModal();
            } else if (res.data.type === true) {
              alert.success(res.data.msg);
            }
            getExpenditures();
            closeModal();
          });
        }}
      >
        {({ handleSubmit, values, isSubmitting, setFieldValue }) => (
          <Form>
            <div className="row">
              <div className="col-md-12">
                <div className="form-group">
                  <label>
                    {" "}
                    Date <span className="text-danger"> * </span>
                  </label>
                  <DatePicker
                    selected={values.expenditure_date}
                    maxDate={new Date()}
                    showDisabledMonthNavigation
                    dateFormat="MMMM d, yyyy"
                    className="form-control"
                    name="expenditure_date"
                    onChange={(date) => setFieldValue("expenditure_date", date)}
                    autoComplete="off"
                    required
                  />{" "}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="form-group">
                  <label>
                    Price <span className="text-danger"> * </span>
                  </label>
                  <Field type="number" className="form-control" name="price" />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="form-group">
                  <label>Description</label>
                  <Field
                    name="description"
                    as="textarea"
                    cols="10"
                    rows="5"
                    className="form-control"
                  ></Field>
                </div>
              </div>
            </div>

            <div className="form-group row">
              <div className="col">
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  onClick={closeModal}
                >
                  Close
                </button>
              </div>
              <div className="col-md-10">
                <button
                  type="submit"
                  className="btn btn-block nt-button-color-default btn-sm"
                >
                  Save{" "}
                  {isSubmitting ? (
                    <span
                      id="login_spinner"
                      className="fa fa-spin fa-spinner"
                    ></span>
                  ) : null}
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/container/dashboard/organizationmanagement/request/expenditure/modal/create_expenditure.js